import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DeviceEnum } from '../../core';
import { CorrectionMenuComponent } from '../../correction';
import { DeformityMenuComponent } from '../../deformity';
import { JpsMenuComponent, RpmMenuComponent } from '../../product';
import { PrinterService } from '../../services';
import { BaseComponent } from '../../shared';
import { ImageElaborationComponent } from '../image-elaboration';


/**
* Component of first vertical sidebar to handle the tools menu.
*/
@Component({
	selector: 'tools-menu',
	templateUrl: './tools-menu.component.html',
	imports: [
		JpsMenuComponent,
		RpmMenuComponent,
		DeformityMenuComponent,
		CorrectionMenuComponent,
		ImageElaborationComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ToolsMenuComponent extends BaseComponent {

	private readonly printSrv = inject(PrinterService);

	get isJPS(): boolean { return this.canvasSrv.currentCase?.device === DeviceEnum.Jps; }
	get isFitbone(): boolean { return this.canvasSrv.currentCase?.device === DeviceEnum.Fitbone; }

	/* UNDO/REDO  */

	undo(): void {
		if (this.isUndoEnabled) {
			this.canvasSrv.dispatch('undo');
		}
	}

	redo(): void {
		if (this.isRedoEnabled) {
			this.canvasSrv.dispatch('redo');
		}
	}

	/* FOOTER MENU  */

	/**
	 * Check if or-plan button is visible. 
	 */
	get isPrintVisible(): boolean {
		return this.stateType === this.stateTypeEnum.deformityAnalysis ||
			this.stateType === this.stateTypeEnum.EOC ||
			this.stateType === this.stateTypeEnum.templating;
	}

	/**
	 * Generate PDF OR plan.
	 */
	printOR(): void {
		if (this.isDeformityDone) {
			this.printSrv.printORPlan();
		}
	}

	/**
	 * Generate Bill of Materials PDF.
	 */
	printBom(): void {
		if (this.isPlateInserted) {
			this.printSrv.printBom();
		}
	}

}
